module.exports = __webpack_public_path__ + "static/media/cv.b852f54b.pdf";